import { useTranslation } from 'next-i18next';
import React from 'react';
import { AgendaEntry, SpeakerEntry, StageComponentInterface } from '../../../../interfaces/pagebuilder';
import { fetchAndSetEventSpeakers } from '../../../../reduxToolkit/slices/commonSlice';
import { useSelector, useDispatch } from '../../../../reduxToolkit/typedRedux';
import { createSpeaker } from '../../../../services/services';
import VyTextField from '../../../common/VyTextField';
import EntrySettingsForm from '../../pageBuilder/Settings/agenda/EntrySettingsForm';
import SpeakerForm from '../../pageBuilder/Settings/speakers/SpeakerSettings/SpeakerForm';
import SpeakersList from '../../pageBuilder/Settings/speakers/SpeakerSettings/SpeakersList';
import MBWDownloadSettings from './Downloads/MBWDownloadSettings';
import MbwSettingAccordion from './MbwSettingAccordion';

interface MBWStageSettingsProps {
  component: StageComponentInterface;
  onChange: (c: StageComponentInterface) => void;
}
const MBWStageSettings = ({ component, onChange }: MBWStageSettingsProps) => {
  const event = useSelector((state) => state.common.event);
  const { t } = useTranslation(['account', 'common']);
  const dispatch = useDispatch();
  function onChangeAgendaEntries(entryList: AgendaEntry[]) {
    onChange({ ...component, entryList });
  }

  async function handleCreateSpeaker(props: SpeakerEntry) {
    if (!event) return;
    delete props._id;
    const speaker = await createSpeaker(event?._id, props);
    const newComponent = { ...component };
    newComponent.entryIds = [...(newComponent.entryIds ?? []), speaker];
    onChange(newComponent);
    dispatch(fetchAndSetEventSpeakers(event._id));
  }

  function onChangeSpeakersEntries(entryIds: SpeakerEntry[]) {
    onChange({ ...component, entryIds });
  }

  return (
    <div className="flex flex-col space-y-2">
      <MbwSettingAccordion title={t('pagebuilder:agenda')}>
        <div className="flex flex-col space-y-2">
          <VyTextField
            fullWidth
            defaultValue={component.agendaTitle}
            label={t('pagebuilder:title')}
            onBlur={(e) => onChange({ ...component, agendaTitle: e.target.value })}
          />
          <EntrySettingsForm component={component} onChange={onChangeAgendaEntries} />
        </div>
      </MbwSettingAccordion>
      <MbwSettingAccordion title={t('pagebuilder:speakers')}>
        <div className="w-full">
          <VyTextField
            fullWidth
            defaultValue={component.speakersTitle}
            label={t('pagebuilder:title')}
            onBlur={(e) => onChange({ ...component, speakersTitle: e.target.value })}
          />
          <SpeakerForm onSpeakerCreated={handleCreateSpeaker} withHasModalOption={false} applyDefaultStyleOnEditor={false} />
          <SpeakersList component={component} onChange={onChangeSpeakersEntries} withHasModalOption={false} />
        </div>
      </MbwSettingAccordion>
      <MbwSettingAccordion title={t('pagebuilder:downloads')}>
        <div className="w-full">
          <VyTextField
            fullWidth
            defaultValue={component.downloadsTitle}
            label={t('pagebuilder:title')}
            onBlur={(e) => onChange({ ...component, downloadsTitle: e.target.value })}
          />
          <MBWDownloadSettings component={component} onChange={onChange} />
        </div>
      </MbwSettingAccordion>
    </div>
  );
};
export default MBWStageSettings;
